import React from 'react'
import StripeButtons from '../../stripes/StripeButtons'
import OvsGrid from '../../OvsGrid'
import PageCustomOvs from '../PageCustomOvs'
import { keys } from 'lodash'

const DashboardNowcastingTemplate = ({
  title,
  className,
  stripeButtons,
  data,
  configMenu,
  selectedItems,
  btnActiveId
}) => {
  return (
    <PageCustomOvs title={title} className={className} configMenu={configMenu}>
      {stripeButtons && <StripeButtons btns={stripeButtons} />}
      {keys(data).map((key) => {
        return (
          <OvsGrid
            items={data[key]}
            title={key}
            selectedItems={selectedItems}
            btnActiveId={btnActiveId}
          ></OvsGrid>
        )
      })}
    </PageCustomOvs>
  )
}

export default React.memo(DashboardNowcastingTemplate)
